module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-theme-3-d3844e712689cc2cf053c78b894398ea.webp";